const hex = Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, "0"));

/** RFC 9562 UUIDv7 — client-generated ids keep optimistic creates collision-free and time-ordered. */
export function uuidv7(): string {
	const bytes = crypto.getRandomValues(new Uint8Array(16));
	const ts = BigInt(Date.now());
	for (let i = 0; i < 6; i++) bytes[i] = Number((ts >> BigInt(40 - i * 8)) & 0xffn);
	bytes[6] = (bytes[6] & 0x0f) | 0x70;
	bytes[8] = (bytes[8] & 0x3f) | 0x80;
	let out = "";
	for (let i = 0; i < 16; i++) {
		if (i === 4 || i === 6 || i === 8 || i === 10) out += "-";
		out += hex[bytes[i]];
	}
	return out;
}
